<!-- <div class="modal fade" id="modaluploadnewversion" tabindex="-1"
	role="dialog"> -->
<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="createForm();">Chiudi</button>
		</p>
		<div doc_add_form #docAddForm (onReturnCallback)="manageModal($event)" (onReturnSpostaDoc)="onDocumentoSpostato($event)"
			[entityList]="entityList" [itemSelected]="itemSelected"></div>
	</div>
</div>
<!-- </div> -->
